import { EventChanges } from "@api-types/event-changes";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export default class EventChangesApiService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/event-changes`;

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static getChanges(
		eventChangeTypeIds: string[],
		eventId: string
	): Promise<EventChanges> {
		const context = getApiRequestContext();

		return httpClient.get(
			`${
				this.baseUrl
			}?eventIds=${eventId}&eventChangeTypeIds=${eventChangeTypeIds.join(
				","
			)}&rpp=100&sort=time|asc`,
			this.getRequestHeaders(context)
		);
	}
}
